/** Keeps old projects and invalid saved values at the normal electrical symbol size. */
export function normalizeEloItemScale(value: number | undefined): number {
  return value !== undefined && Number.isFinite(value) ? Math.min(2, Math.max(0.5, value)) : 1;
}

/** Scales a symbol around its plan anchor without changing the device position. */
export function eloItemScaleTransform(x: number, y: number, scale: number, sizeFactor = 1): string | undefined {
  const normalized = normalizeEloItemScale(scale) * sizeFactor;
  if (normalized === 1) return undefined;
  return `translate(${x} ${y}) scale(${normalized}) translate(${-x} ${-y})`;
}
